import React, {  } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import Card from '../../../components/Card';
import { distances } from '../../../styles/constants';
import { P } from '../../../components/Typography';
import { NextButton, BackButton } from '../../common/components';

interface PublicationProps {
    onPreviousStage: () => void;
    isImageLoading: boolean;
}

const Publication = (
    {
        onPreviousStage,
        isImageLoading,
    }: PublicationProps
) => {
    const { t } = useTranslation();

    return (
        <Card
            title={t('marketing.campaign.publish')}
            subtitle={t('marketing.campaign.publish_send_email')}
            shortHr
            marginBottom={distances.tiny}
        >
            <TextWrapper>{/* <P>{t('marketing.campaign.check_if_ok')}</P> */}</TextWrapper>
            <ButtonsWrapper>
                <FurtherButtons>
                    {/* <Button type='button' onClick={() => {}}>
                        {t('marketing.campaign.preview_campaign')}
                    </Button> */}
                    <div>
                        <NextButton type="submit" disabled={isImageLoading}>
                            {t('marketing.campaign.publish_now')}
                        </NextButton>
                        {isImageLoading && (
                            <UploadingImageText>{t('marketing.campaign.uploading_images')}</UploadingImageText>
                        )}
                    </div>
                </FurtherButtons>
                <BackButton type="button" onClick={onPreviousStage}>
                    {t('marketing.campaign.back')}
                </BackButton>
            </ButtonsWrapper>
        </Card>
    );
};

const TextWrapper = styled.div`
    margin: ${distances.normal} 0;
`;

const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: space-between;

    @media (max-width: 768px) {
        display: block;

        > *:first-child {
            margin-bottom: ${distances.small};
        }
    }
`;

const FurtherButtons = styled.div`
    display: flex;

    > *:first-child {
        margin-right: ${distances.small};
    }
`;

const UploadingImageText = styled(P as any)`
    line-height: 38px;
    padding-left: ${distances.tiny};
`;

export default Publication;
